import { useState } from 'react'

import { useIdleTimer } from 'react-idle-timer'

import { Dialog, DialogContent, DialogTitle } from '@mui/material'

import Typography from '@mui/material/Typography'

import Button from '@mui/material/Button'

import type { ChildrenType } from '@core/types'
import { handleLogout } from '@/utils/auth'
import { useGetApiConfigs } from '@/api/generated/endpoints/configs/configs'

export default function IdleDetectionWrapper({ children }: ChildrenType) {
  const [open, setOpen] = useState<boolean>(false)

  // Config data should be there because we prefetched it
  const { data: configsResponse } = useGetApiConfigs()
  const data = configsResponse?.data

  const onClose = () => {
    setOpen(false)
  }

  const sessionDuration = Number(data?.find(c => c.key === 'session_duration')?.value || '15')

  const { activate } = useIdleTimer({
    onIdle: () => handleLogout(),
    onPrompt: () => setOpen(true),
    timeout: sessionDuration * 1_000 * 60, // Idle is in minute so I need to convert it to milliseconds
    promptBeforeIdle: 1_000 * 60 * Math.round(sessionDuration / 3), // Prompt 1/3 of time before idle
    throttle: 500
  })

  const handleStillHere = () => {
    activate()
    onClose()
  }

  return (
    <>
      {children}
      <Dialog open={open}>
        <DialogTitle>Session about to expire</DialogTitle>
        <DialogContent className={'flex gap-x-4 gap-y-6 flex-wrap'}>
          <Typography className={'w-full'}>
            As a security precaution, sessions end after{' '}
            {parseInt(data?.find(c => c.key === 'session_duration')?.value || '15')} Minutes
            <br />
            Click OK to continue your current session.
          </Typography>
          <Button variant={'contained'} onClick={handleStillHere}>
            Ok
          </Button>
        </DialogContent>
      </Dialog>
    </>
  )
}
